import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';

import Tabs from 'components/Tabs';
import Tab from 'components/Tab';
import SnackBar from 'components/SnackBar';
import Header from 'pages/Supplies/components/Header';
import FormulaForm from 'pages/Supplies/components/Formula/components/FormulaForm';
import InventoryFormPanel from 'pages/Supplies/components/Inventory/FormPanel';
import ManufacturerFormPanel from 'pages/Supplies/components/Manufacturers/FormPanel';
import GlassBeadFormPanel from 'pages/Supplies/components/GlassBeads/FormPanel/FormPanel';
import { fetchPersonalProfile } from 'store/personalProfile/personalProfileOperations';
import ArchiveTab from './components/ArchiveTab';
import { TABS } from './constants/tabs';
import useStyles from './styles';

const SuppliesArchivePage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [snackbar, setSnackbar] = useState(null);
  const [drawer, setDrawer] = useState(null);

  useEffect(() => {
    dispatch(fetchPersonalProfile());
  }, []);

  const closeDrawer = useCallback(() => setDrawer((prev) => ({ ...prev, isOpen: false })), []);

  const onSelect = useCallback(
    (data) => setDrawer({ isOpen: true, type: activeTab.drawer, data }),
    [activeTab]
  );

  return (
    <>
      <div className={classes.root}>
        <Header title="Archive">
          <Button
            variant="outlined"
            color="primary"
            disableTouchRipple
            className={classes.backButton}
            onClick={() => navigate('/supplies')}
          >
            Back To Supply Register
          </Button>
        </Header>
        <Tabs
          value={activeTab.index}
          onChange={(event, newValue) => setActiveTab(TABS.find((t) => t.index === newValue))}
          className={classes.tabs}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.index}
              label={tab.label}
              href={tab.href}
              disableRipple
              component="a"
              onClick={(event) => event.preventDefault()}
            />
          ))}
        </Tabs>
        <ArchiveTab
          key={activeTab.name}
          tab={activeTab}
          onSelect={onSelect}
          setSnackbar={setSnackbar}
        />
      </div>
      {drawer && (
        <Drawer anchor="right" open={drawer.isOpen}>
          {drawer.type === 'formula' && (
            <FormulaForm
              closeDrawer={closeDrawer}
              data={drawer.data}
              type="view"
              snackbarInfo={setSnackbar}
            />
          )}
          {drawer.type === 'inventory' && (
            <InventoryFormPanel
              closeDrawer={closeDrawer}
              data={drawer.data}
              type="view"
              onSave={closeDrawer}
              setSnackbar={setSnackbar}
            />
          )}
          {drawer.type === 'manufacturer' && (
            <ManufacturerFormPanel
              closeDrawer={closeDrawer}
              data={drawer.data}
              type="view"
              onSave={closeDrawer}
            />
          )}
          {drawer.type === 'glassBead' && (
            <GlassBeadFormPanel
              closeDrawer={closeDrawer}
              data={drawer.data}
              type="view"
              onSave={closeDrawer}
            />
          )}
        </Drawer>
      )}
      {snackbar && <SnackBar closeSnackbar={() => setSnackbar(null)} {...snackbar} isOpen={true} />}
    </>
  );
};

export default SuppliesArchivePage;
